// removed by extract-text-webpack-plugin
module.exports = {"header":"Header__header__1hCuT","content":"Header__content__2rdEG","no-padding":"Header__no-padding__1Z4et","logo":"Header__logo__sPXsP"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Header/Header.scss
// module id = 1273
// module chunks = 0